import { useMapsLibrary } from '@vis.gl/react-google-maps';
import { useEffect, useMemo, useState } from 'react';

function useGoogleMapsPlacesService(map) {
  const [placesService, setPlacesService] = useState(null);

  const placesLibrary = useMapsLibrary('places');
  const isPlacesServiceLoaded = useMemo(
    () => placesService != null,
    [placesService]
  );

  useEffect(() => {
    if (!placesLibrary || !map) return;
    const service = new placesLibrary.PlacesService(map);

    if (service != null) {
      setPlacesService(service);
    }
  }, [placesLibrary, map]);

  return {
    isPlacesServiceLoaded,
    placesService,
  };
}

export { useGoogleMapsPlacesService };
